var cilMemory = ["512 512", "<path fill='var(--ci-primary-color, currentColor)' d='M192,320H320V192H192Zm32-96h64v64H224Z' class='ci-primary'/><path fill='var(--ci-primary-color, currentColor)' d='M32,288v32h72v88h88v72h32V408h64v72h32V408h88V320h72V288H408V224h72V192H408V104H320V32H288v72H224V32H192v72H104v88H32v32h72v64ZM136,136H376V376H136Z' class='ci-primary'/>"];

export { cilMemory };
